'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { z } from 'zod';
import { usePostApiUsersResetToken } from '@/api/backoffice/users/users';
import { Button } from '@/components/button';
import { Input } from '@/components/Input/Input';
import { useAuthDialog } from '@/context/AuthDialogProvider';

// Zod validation schema
const SendResetPasswordLinkFormSchema = z.object({
  email: z.email().max(50, 'Email is too long'),
});

export const SendResetPasswordLinkForm = () => {
  const { toggleIsOpen } = useAuthDialog();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<z.infer<typeof SendResetPasswordLinkFormSchema>>({
    resolver: zodResolver(SendResetPasswordLinkFormSchema),
    defaultValues: {
      email: '',
    },
  });

  const { mutateAsync: sendResetPasswordLink, isPending } =
    usePostApiUsersResetToken({
      mutation: {
        onSuccess: () => {
          toast.success('Password reset link sent successfully to your email');
          toggleIsOpen();
        },
        onError: () => {
          toast.error('Failed to send password reset email. Try again later');
        },
      },
    });

  const onSubmit = async (
    data: z.infer<typeof SendResetPasswordLinkFormSchema>
  ) => {
    try {
      await sendResetPasswordLink({
        data: {
          ...data,
          url: window.location.origin,
        },
      });
    } catch (error) {
      console.error('Password reset link failed:', error);
    }
  };

  return (
    <div className="w-[20rem]">
      <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
        <h2 className="font-semibold text-xl">Reset password</h2>
        <Input
          {...register('email')}
          error={errors.email?.message}
          label="Email"
          placeholder="Email"
          type="email"
        />

        <Button disabled={isPending} size="lg" type="submit" variant="primary">
          Reset password
        </Button>
      </form>
    </div>
  );
};
